export const ModelList = [
    {
        'group':'Spring',
        'name':'Models',
        'models':
        [
            {name:'Drone',url:'./models/drone.glb'},
            {name:'Ortho8K',url:'./models/Ortho8192.glb'},
            {name:'Ortho1k',url:'./models/Ortho1w.glb'},
            // {name:'Ortho16384',url:'./models/Ortho16384.glb'},
            {name:'MainShaft',url:'./models/MainShaft.glb'},
            {name:'NewShaft',url:'./models/NewShaft.glb'},
            {name:'OldShaft',url:'./models/OldShaft.glb'},
            {name:'Shafts',url:'./models/Shafts.glb'},
            {name:'MainShaft_Orebody',url:'./models/Orebody.glb'},
            {name:'NewShaft_Orebody',url:'./models/Parallel_Orebody.glb'},
            {name:'OldShaft_Orebody',url:'./models/Orebody1.glb'},
            {name:'MainShaftFault',url:'./models/Fault.glb'},	
            {name:'Claims',url:'./models/Claims.glb'},

            {name:'Claim_17908B',url:'./models/17908Bs.glb'},
            {name:'Claim_17908',url:'./models/17908.glb'},
            {name:'Claim_17874B',url:'./models/17874B.glb'},
            {name:'Claim_17874',url:'./models/17874.glb'},

            // Example: collar-only holes (CSV in public/files/Collar.csv)
            // Required headers: Hole_ID,NAT_East,NAT_North,NAT_RL,Collar_Azimuth,Collar_Dip,Max_Depth
            {name:'CollarHoles', type:'cachedHoles', hole_url:'./files/Collar.csv', assay_url:null, dataset:null, holetype:null, holeColor:'whitesmoke'},
            {name:'Holes2026', type:'cachedHoles', hole_url:'./files/Collar2026.csv', assay_url:'./files/Assays2026.csv', dataset:null, holetype:null, holeColor:'black'},
        ]
    }
]